@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

@keyframes bounceIn {
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}

.newTestimonials {
  position: absolute;
  top: 208px;
  z-index: 100;
  flex-direction: column;
  align-items: center;
  display: none;

  @include for-tablet-portrait-down {
    top: unset;
    right: unset;
    width: 100%;
  }

  &.noMargin {
    margin-top: 0 !important;
  }

  &.newFormat {
    position: relative;
    min-width: 332px;
    min-height: 200px;
    align-self: center;
    display: flex;
    width: initial;
    margin-top: 48px;

    .picture {
      width: 54px;
      height: 54px;
      background-size: cover;
      z-index: 1;
    }

    .quote {
      position: absolute;
      span {
        @include md-sohne;
        display: inline;
        top: 20px;
        left: -5px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 110%;
      }
    }

    .profile {
      position: absolute;
      display: flex;
      flex-direction: row;
      bottom: 30px;
      margin: 0 auto;
      background-color: transparent;
      border: none;
      .positionAndCompany {
        flex-direction: row;
        text-align: start;
        gap: 4px;
      }
    }
    .name {
      text-align: start;
    }
    .info {
      display: flex;
      flex-direction: column;
    }
  }

  .quote {
    z-index: 100;
    position: relative;

    &.animate {
      animation-name: bounceIn;
      animation-duration: 600ms;
      animation-fill-mode: both;
    }

    span {
      @include spinner-regular;
      font-size: 20px;
      line-height: 110%; /* 22px */
      text-align: center;
      color: var(--neutral-90);

      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-self: center;
      left: 0;
      top: -15px;

      padding-left: 25px;
      padding-right: 15px;
    }
  }

  .picture {
    border-radius: 230px;
    background: var(--blaze-beige);
    margin-top: -20px;
    margin-bottom: -20px;
    width: 176px;
    height: 176px;

    &.animate {
      @include fadein(0.6s);
    }
  }

  .profile {
    display: inline-flex;
    padding: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border: 1.467px solid black;
    background: #fae7a3;
    color: #161b1d;
    text-align: center;

    &.animate {
      @include fadein(0.6s);
    }

    @include for-tablet-portrait-down {
      gap: 8px;
    }

    .name {
      @include spinner-bold;
      padding-bottom: 3px;
      @include for-tablet-portrait-down {
        line-height: 10px;
      }
    }

    .positionAndCompany {
      display: inline-flex;
      flex-direction: column;
      padding-top: 3px;
      .position,
      .company {
        @include spinner-regular;
      }
    }
  }
}

.testimonials {
  position: absolute;
  top: 208px;
  right: -190px;
  z-index: 100;
  flex-direction: column;
  align-items: center;
  display: none;

  &.isStartTrialPage {
    top: 100px;
  }

  @include for-desktop-up {
    display: flex;
  }

  @include for-dwarf-desktops {
    top: 100px;
  }

  @include for-tablet-portrait-down {
    top: unset;
    right: unset;
    bottom: 10px;
    width: 100%;
  }

  @include for-dwarf-devices {
    display: none;
  }

  &.inline {
    position: relative;
    display: none;

    @include for-tablet-portrait-max {
      display: flex;
      bottom: unset;
      right: unset;
      top: unset;
    }

    .picture {
      width: 70px;
      height: 70px;
      background-size: contain;
      z-index: 100;
      margin-bottom: -5px;
    }

    .positionAndCompany {
      font-size: 14px;
      line-height: 100%;
    }

    .quote {
      span {
        font-size: 16px;
        line-height: 100%;
        margin-top: 5px;
      }
    }
  }

  &.horizontal {
    position: relative;
    min-width: 332px;
    min-height: 164px;
    align-self: center;
    right: unset;
    left: unset;
    top: unset;
    bottom: unset;
    display: flex;
    width: initial;

    .picture {
      position: absolute;
      top: 80px;
      width: 122px;
      height: 122px;
      background-size: cover;
      right: 0;
      z-index: 1;
    }

    .quote {
      position: absolute;
      left: 0;

      span {
        left: -5px;
        top: -5px;
        padding-left: 25px;
        padding-right: 15px;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 110%;
      }
    }

    .profile {
      position: absolute;
      bottom: -10px;
      left: 6px;
      padding: 8px;
      background-color: var(--blaze-bright-yellow);

      .positionAndCompany {
        flex-direction: row;
        gap: 4px;
      }
    }
  }

  .quote {
    z-index: 100;
    position: relative;

    &.animate {
      animation-name: bounceIn;
      animation-duration: 600ms;
      animation-fill-mode: both;
    }

    span {
      @include md-sohne;
      font-size: 20px;
      line-height: 110%; /* 22px */
      text-align: center;
      color: var(--neutral-90);

      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-self: center;
      left: 0;
      top: -15px;

      padding-left: 25px;
      padding-right: 15px;
    }
  }

  .picture {
    border-radius: 230px;
    border: 1.25px solid black;
    background: var(--blaze-beige);
    margin-top: -30px;
    margin-bottom: -20px;
    width: 176px;
    height: 176px;

    &.animate {
      @include fadein(0.6s);
    }
  }

  .profile {
    display: inline-flex;
    padding: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border: 1.467px solid black;
    background: #fae7a3;
    color: #161b1d;
    text-align: center;

    &.animate {
      @include fadein(0.6s);
    }

    @include for-tablet-portrait-down {
      gap: 8px;
    }

    .name {
      @include spinner-bold;

      @include for-tablet-portrait-down {
        line-height: 10px;
      }
    }

    .positionAndCompany {
      display: inline-flex;
      flex-direction: column;

      .position,
      .company {
        @include spinner-regular;
      }
    }
  }
}

.quoteContent {
  @include md-sohne;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%;
  text-align: center;
  padding: 0 20px;
}
